import React from "react";
import { Link, useLocation } from "react-router-dom";

const ClientPaymentSuccess = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const txnid = params.get("txnid") || "";
  const amount = params.get("amount") || "";
  const noticeId = params.get("noticeId") || "";

  return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "#f0f7ff", padding: "24px" }}>
      <div style={{ background: "#fff", borderRadius: "16px", boxShadow: "0 4px 24px rgba(23,92,143,0.10)", padding: "48px 40px", maxWidth: "480px", width: "100%", textAlign: "center" }}>
        <div style={{ fontSize: "56px", marginBottom: "16px" }}>✅</div>
        <h2 style={{ color: "#175c8f", fontWeight: 700, marginBottom: "8px" }}>Payment Successful!</h2>
        <p style={{ color: "#5b7088", marginBottom: "24px" }}>Your payment to the lawyer has been processed successfully.</p>

        {(txnid || amount || noticeId) && (
          <div style={{ background: "#f0f7ff", border: "1px solid #d0e6f8", borderRadius: "10px", padding: "16px", marginBottom: "24px", textAlign: "left" }}>
            {noticeId && <div style={{ marginBottom: "6px" }}><span style={{ color: "#6d8298", fontSize: "13px" }}>Notice ID</span><br /><strong style={{ color: "#102a43" }}>{noticeId}</strong></div>}
            {amount && <div style={{ marginBottom: "6px" }}><span style={{ color: "#6d8298", fontSize: "13px" }}>Amount Paid</span><br /><strong style={{ color: "#102a43" }}>₹ {amount}</strong></div>}
            {txnid && <div><span style={{ color: "#6d8298", fontSize: "13px" }}>Transaction ID</span><br /><strong style={{ color: "#102a43", fontSize: "13px", wordBreak: "break-all" }}>{txnid}</strong></div>}
          </div>
        )}

        <Link to="/client-my-notices" style={{ display: "inline-block", background: "#175c8f", color: "#fff", padding: "12px 28px", borderRadius: "8px", textDecoration: "none", fontWeight: 600 }}>
          Back to My Notices
        </Link>
      </div>
    </div>
  );
};

export default ClientPaymentSuccess;
